(function () {
    'use strict';

    angular.module('UndergroundWebApp')
        .directive('duplicatedKeycardWarning', duplicatedKeycardWarning);

    duplicatedKeycardWarning.$inject = ['$rootScope'];

    function duplicatedKeycardWarning($rootScope) {
        return {
            restrict: 'E',
            scope: {
                visible: '=?',
            },
            template: `
                <div ng-if="isVisible">
                    <div id="duplication-modal-container">
                        <div id="modal" class="duplicated-keycard-warning-modal">
                            <h3>{{'KEYCARD_DUPLICATIONS_WARNING_MESSAGE' | translate}}</h3>
                            <ul>
                                <li ng-repeat="duplicatedCard in duplicatedCards track by $index">
                                    <div class="duplicated-card">
                                        <b>{{ 'KEYCARD_DUPLICATION_WARNING_CARD_NUMBER' | translate }}:</b> {{duplicatedCard.cardNumber}} 
                                        <b>{{ 'KEYCARD_DUPLICATION_WARNING_GROUP' | translate }}:</b> {{getGroupName(duplicatedCard.groupId)}} 
                                        <b>{{ 'KEYCARD_DUPLICATION_WARNING_ACTIVE' | translate }}:</b> {{duplicatedCard.isActive}} 
                                        <b>{{ 'KEYCARD_DUPLICATION_WARNING_ARHCIVED' | translate }}:</b> {{duplicatedCard.isArchived}}
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="row bottom-button-group to-center">
                            <button class="btn btn-default button-shadow" ng-click="close()" tabindex="13">
                                <i class="fa fa-close" aria-hidden="true"></i>
                                <span>{{'G_CLOSE_BUTTON' | translate}}</span>
                            </button>
                        </div>
                    </div>
                    <div class="duplication-overlay"></div>
                </div>
            `,
            link: function (scope) {

                scope.duplicatedCards = $rootScope.duplicatedCards;
                scope.accessItemGroups = $rootScope.accessItemGroups;
                scope.isVisible = scope.visible !== undefined
                    ? scope.visible
                    : $rootScope.isDuplicationWarningVisible;

                scope.$watch(
                    function () { return $rootScope.duplicatedCards; },
                    function (newVal) { scope.duplicatedCards = newVal; }
                );

                scope.$watch(
                    function () { return $rootScope.accessItemGroups; },
                    function (newVal) { scope.accessItemGroups = newVal; }
                );

                scope.$watch(
                    function () { return $rootScope.isDuplicationWarningVisible; },
                    function (newVal) {
                        scope.isVisible = newVal;
                    }
                );

                scope.getGroupName = function (groupId) {
                    const group = scope.accessItemGroups.find(g => g.id === groupId);
                    return group ? group.name : '';
                };

                scope.close = function () {
                    $rootScope.duplicatedCards = [];
                    $rootScope.accessItemGroups = [];
                    $rootScope.isDuplicationWarningVisible = false;
                };
            }
        };
    }

})();
